$(document).ready(function() {
  function displayAnnexInput () {
    const type = $(this).data('type');

    $("#annex_" + type).show();
  }

  if ($('form.edit_structure.structure_kycs').length > 0) {
    $('input.structure_document').change(displayAnnexInput);
  }
});
